/**
 * SocialLoginButtons — Google OAuth button for auth pages.
 */

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

const GoogleIcon = () => (
  <svg
    className="h-[18px] w-[18px] shrink-0"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    aria-hidden="true"
  >
    <path
      fill="#4285F4"
      d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"
    />
    <path
      fill="#34A853"
      d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.92v2.32A9 9 0 0 0 9 18z"
    />
    <path
      fill="#FBBC05"
      d="M3.97 10.72A5.41 5.41 0 0 1 3.68 9c0-.6.1-1.18.29-1.72V4.96H.92A9 9 0 0 0 0 9c0 1.45.35 2.82.92 4.04l3.05-2.32z"
    />
    <path
      fill="#EA4335"
      d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0A9 9 0 0 0 .92 4.96L3.97 7.28C4.68 5.16 6.66 3.58 9 3.58z"
    />
  </svg>
);

export function SocialLoginButtons() {
  const { signInWithGoogle } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const { error } = await signInWithGoogle();
      if (error) console.error('Google sign-in error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      className="h-12 w-full gap-2.5 rounded-[10px] border border-warm-border bg-paper text-[15px] font-medium text-ink shadow-none transition-colors hover:bg-paper-2 hover:text-ink disabled:cursor-not-allowed disabled:opacity-70"
      onClick={handleClick}
      disabled={isLoading}
      title="Continue with Google"
    >
      <GoogleIcon />
      {isLoading ? 'Signing in…' : 'Continue with Google'}
    </Button>
  );
}
